import axios from 'axios';
import React from 'react';

class Activities extends React.Component {
  constructor(props) {
    super(props);
    const siteLanguage = localStorage.getItem('siteLanguage') || 'en';
   const dummyData = {
      section_name: {
        en: "Why Choose Us",
        ur: "ہمیں کیوں منتخب کریں "
      },
      section_title: {
        en: "Explore Our Key Features",
        ur: "ہماری نمایاں خصوصیات دریافت کریں"
      },
      sub_sections: [
        {
          title: {
            en: "Esteemed Islamic Scholars",
            ur: "معزز اسلامی اسکالرز "
          },
          description: {
            en: "Our online Quran classes are led by highly qualified Islamic scholars and expert tutors.",
            ur: "ہمارے آن لائن قرآن کلاسز تجربہ کار اور اعلیٰ تعلیم یافتہ اسلامی علما اور ماہر اساتذہ کی زیر نگرانی ہوتے ہیں۔ ",
          },
          images: {
            src: "https://lqe-assets.learnquraneasily.in/1747062934201_Esteemed_Scholars.png"
          }
        },
        {
          title: {
            en: "Personalized Instruction",
            ur: "انفرادی رہنمائی ",
          },
          description: {
            en: "One-to-one teaching tailored to every student's unique needs.",
            ur: "ہر طالب علم کی ضروریات کے مطابق ایک سے ایک کی بنیاد پر خصوصی تعلیم دی جاتی ہے۔ ",
          },
          images: {
            src: "https://lqe-assets.learnquraneasily.in/1747063005711_Personalized.png",
            name: "Icon 2"
          }
        }
      ]
    };
   this.state = {
      siteLanguage: siteLanguage,
      section_name: dummyData.section_name[siteLanguage],
      section_title: dummyData.section_title[siteLanguage],
      activitiesData: dummyData.sub_sections.map(item => ({
        icon: item.images.src,
        icon_text: item.images.name,
        title: item.title[siteLanguage],
        description: item.description[siteLanguage],
        link: "/about",
        linkText: "Learn More"
      }))
    };
  }
  componentDidMount() {
     const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const { siteLanguage } = this.state;
    // return
    axios
      .post(`${BackendUrl}/choose-us/Multiple/1`)
      .then((response) => {
        const data = response.data.data[0];

        const activitiesData = data.sub_sections.map(item => ({
          icon: item.images.src || "default-icon",
          icon_text: item.images.name || "default-icon",
          title: item.title[siteLanguage] || item.title.en,
          description: item.description[siteLanguage] || item.description.en,
          link: "/about",
          linkText: "Learn More",
        }));

        this.setState({
          section_name: data.section_name[siteLanguage] || data.section_name.en,
          section_title: data.section_title[siteLanguage] || data.section_title.en,
          activitiesData
        });
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
      });
  }
  render() {
    const { activitiesData , section_name, section_title, siteLanguage } = this.state;

    return (
      <div className={`container-fluid activities pb-3 ${siteLanguage  === 'ur' ? ' direction-rtl' : ''}`}>
        <div className="container">
          <div className="mx-auto text-center mb-3" style={{ maxWidth: "700px" }}>
            <p className="fs-5 text-uppercase text-primary">{section_name}</p>
            <h4 className="display-6">{section_title}</h4>
          </div>
          <div className="row g-4">
            {activitiesData.map((activity, index) => (
              <div className="col-lg-6 col-xl-4" key={index}>
                <div className="activities-item justify-content-sm-start p-4">
                  <img src={activity?.icon} alt={activity.icon} className="img-fluid w-25" />
                  <div className="mx-2">
                    <h4>{activity.title}</h4>
                    <p className="mb-4">{activity.description}</p>
                    <a href='/our-course' className="btn btn-primary px-3">
                     {siteLanguage  === 'ur' ? "ہمارا کورس دیکھیں" : "View Our Course"}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Activities;
